import React from 'react'
import { ScrollView, StyleSheet, TouchableOpacity, View } from 'react-native'

import { DS } from '@/design-system'

interface NavCardProps {
  title: string
  handler: () => void
  showHeader?: boolean
  isClickable?: boolean
  scrollEnabled?: boolean
  children?: React.ReactNode
}

export function NavCard({
  title,
  handler,
  showHeader = true,
  isClickable = true,
  scrollEnabled = false,
  children
}: NavCardProps) {
  const content = (
    <View style={[styles.card, scrollEnabled && styles.cardFull]}>

      {showHeader && (
        <View style={styles.cardRow}>
          <DS.Text variant="Heading 5/Medium" style={styles.cardRowTitle} textAlign="center">
            {title}
          </DS.Text>
          <DS.Icon name="Arrow---right" size={20} color="Global/Black" />
        </View>
      )}

      {children && (
        <View style={{ maxHeight: '100%' }}>
          <ScrollView showsVerticalScrollIndicator={false} scrollEnabled={scrollEnabled}>
            {children}
          </ScrollView>
        </View>
      )}
    </View>
  )

  if (!isClickable) {
    return content
  }

  return (
    <TouchableOpacity onPress={handler} activeOpacity={0.7}>
      {content}
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: DS.palette['Global/White'],
    borderRadius: DS.spacing[8],
    padding: DS.spacing[16],
    gap: 8
  },
  cardFull: {
    flexShrink: 1,
    minHeight: 0
  },
  cardRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: DS.spacing[12]
  },
  cardRowTitle: {
    flex: 1
  }
})
